module.exports = __webpack_public_path__ + "static/index/img/baikal-1009.e64d892e.jpg";